<template>
    <div class="org-highlights">
        <IconTextRow v-if="address && isOrgFieldVisible(org, 'address')" icon="location">
            {{ address }}
        </IconTextRow>

        <IconTextRow v-if="org.type" icon="organization" variant="default">
            {{ valueLookup(org.type, orgTypes) }}
        </IconTextRow>

        <IconTextRow v-if="org.ico && isOrgFieldVisible(org, 'ico')" icon="id" variant="default">IČO: {{ org.ico }}</IconTextRow>

        <IconTextRow v-if="org.web && isOrgFieldVisible(org, 'web')" icon="web" variant="default">
            <a class="link break-all" :href="formattedUrl" rel="nofollow" target="_blank" @click="trackWebClick">
                {{ webHostname }}
            </a>
        </IconTextRow>

        <OrgSocialNetworksBlock v-if="isOrgFieldVisible(org, 'social')" :org="org" />
    </div>
</template>

<script setup lang="ts">
import { optionType, orgTypes, valueLookup } from '#shared/types/dictionary'
import type { Org } from '#shared/types/Org'
import { useOrgs } from '@/composables/orgs/useOrgs'
import { useExponea } from '@/composables/exponea/useExponea'

const props = defineProps<{
    org: Org
}>()

const exponea = useExponea()
const { isOrgFieldVisible } = useOrgs()

const address = computed((): string => {
    const country = props.org.country !== 'Slovensko' && props.org.country
    return [props.org.address, props.org.zip, props.org.geocity, country].filter(Boolean).join(', ')
})

const formattedUrl = computed((): string => {
    return (
        (props.org.web?.indexOf('http://') !== 0 && props.org.web?.indexOf('https://') !== 0 ? 'http://' : '') +
        props.org.web
    )
})

// Full URLs with paths and tracking params overflow the header on mobile; the hostname is enough.
const webHostname = computed((): string => {
    try {
        return new URL(formattedUrl.value).hostname.replace(/^www\./, '')
    } catch {
        return props.org.web || ''
    }
})

const trackWebClick = () => {
    exponea.track('klik_web_partnera', { url: props.org.web })
}
</script>
